import React, {Fragment, useState} from 'react'
import {Button} from "../../../ui-components";
import styles from "../../er-request/components/styles.module.scss";
import {TrashIcon, AcceptedIconGradient} from "../../../assets";
import {Modal, Spinner} from "../../../shared";
import {useAppDispatch, useAppSelector} from "../../../core/hooks";
import {dpCancelErOffer} from "../../requests/er-thunk";

const DpOffersList = () => {

  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [brigade_uuid, setBrigadeUuid] = useState<string>('')
  const {pool, request} = useAppSelector(state => state.requests)
  const dispatch = useAppDispatch()
  return (
    <div id={styles.offersContainer}>
      {pool.request_brigade?.map((el, i) =>
        <div key={i} className={styles.offerWrapper}>
          <div className={styles.info}>
            <p className={styles.textMain}>
              Отправленное предложение {i + 1}
            </p>
            <div style={{display: "flex", justifyContent: "space-between", width: "100%"}} className='d-flex'>
              <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>Бригада</p> {el.brigade_type}</p>
              <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>Время доезда</p> {el.eta} мин.</p>
              <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>Цена</p> {el.price} руб.</p>
              {el?.price_hospitalization ? <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>Цена с госп.</p> {el?.price_hospitalization} руб.</p> : null}
            </div>
            {el.distance ? <div style={{marginTop: 10, display: "flex", justifyContent: "space-between"}} className='d-flex'>
              <p
                className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>Километраж за  </p>{request?.region === 2 ? "МКАД" : "КАД"}</p>
              <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>км </p>{el.distance}</p>
              <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>руб/км </p>{el.distance_price}</p>
              <p className={styles.dpText}><p style={{fontWeight: "bold" ,fontSize: 12, color: "rgb(54, 94, 222)"}}>Цена</p> {el.distance * el.distance_price} руб.</p>
            </div> : null}
          </div>
          <div className={styles.actionBox}>
            {el.approved_by  ? <AcceptedIconGradient className={styles.acceptedIcon}/> :
              <Fragment>
                <Spinner />
                <TrashIcon onClick={() => {
                  setBrigadeUuid(el.uuid)
                  setModalOpen(true)
                }} className={styles.trash}/>
              </Fragment>
            }
          </div>
        </div>
      )}
      <Modal open={modalOpen}
             closeIcon
             className={styles.cancelOfferModal}
             title={'Отменить Предложение'}
             handleClose={() => setModalOpen(false)}>
        <p className="modalText mb-50">Вы уверены, что хотите отменить предложение?</p>
        <div className='d-flex space-between'>
          <Button className={styles.modalBtn} type='contained' onClick={() => dispatch(dpCancelErOffer(brigade_uuid))}>Да</Button>
          <Button className={`ml-30 ${styles.modalBtn}`} type='outlined' onClick={() => setModalOpen(false)} >Нет</Button>
        </div>
      </Modal>
    </div>
  )
}

export default DpOffersList
